// Shared responsive typography constants for user dashboard components.
// Import these to keep font sizing consistent across Prognosis, WhatToExpect, and Advice tabs.

export const FONT_SIZE_CARD_HEADER = 'clamp(15px, 1.4vw, 22px)';
export const FONT_SIZE_SECTION_HEADER = 'clamp(14px, 1.15vw, 18px)';
export const FONT_SIZE_SECTION_TEXT = 'clamp(12px, 1vw, 15px)';
export const FONT_SIZE_SUB_TEXT = 'clamp(11px, 0.9vw, 14px)';

// Spread into makeStyles definitions to share base typography styles.
export const sharedTypographyStyles = {
  cardHeaderTitle: {
    color: "#002D55",
    fontWeight: "bold",
    fontSize: FONT_SIZE_CARD_HEADER,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    color: '#002D55',
    marginBottom: 8,
    marginTop: 4,
    letterSpacing: 0.2,
    fontSize: FONT_SIZE_SECTION_HEADER,
  },
  sectionText: {
    color: '#002D55',
    marginBottom: 6,
    marginTop: 2,
    lineHeight: 1.6,
    fontSize: FONT_SIZE_SECTION_TEXT,
  },
  subText: {
    color: '#002D55',
    marginBottom: 6,
    marginTop: 8,
    lineHeight: 1.6,
    fontSize: FONT_SIZE_SUB_TEXT,
  },
};
